import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { QueryKey, UseQueryOptions } from 'react-query';
import http from '../config/http-service';
import type { GetRestaurantInquiriesParams, RestaurantInquiryListResponse } from './types';
import { restaurantInquiriesEndpoint } from './use-create-restaurant-inquiry-api';

// GET api/v1/cms/restaurant-inquiries — paginated list with optional filters
// (restaurantId, masterProductId, status, paymentOption, hasNewMatches) and
// includeNewMatches to attach newMatchesCount per row. Defaults to page 1,
// limit 20.
type TData = RestaurantInquiryListResponse;
type TError = AxiosError;
type Options = Omit<UseQueryOptions<TData, TError, TData, QueryKey>, 'queryKey' | 'queryFn'>;

export function useGetRestaurantInquiriesApi(params: GetRestaurantInquiriesParams = {}, options?: Options) {
  const query = { page: 1, limit: 20, ...params };

  // Drop undefined/null filters so we don't send `?restaurantId=undefined`.
  const cleaned = Object.fromEntries(Object.entries(query).filter(([, v]) => v !== undefined && v !== null));

  return useQueryWrapper<TData, TError>(
    [restaurantInquiriesEndpoint, query],
    async () => {
      const response = await http.get(restaurantInquiriesEndpoint, { params: cleaned });
      return response.data;
    },
    { keepPreviousData: true, ...options }
  );
}
